import React, { useState } from 'react'
import {
    Modal,
    ModalOverlay,
    ModalContent,
    ModalHeader,
    ModalCloseButton,
    ModalBody,
    ModalFooter,
    Button,
    FormControl,
    FormLabel,
    Input,
    FormErrorMessage,
    Stack,
    useToast
} from '@chakra-ui/react'

const ResetPasswordModal = ({ isOpen, onClose, resetToken }) => {
    const toast = useToast()
    const [formData, setFormData] = useState({
        password: '',
        confirmPassword: ''
    })
    const [errors, setErrors] = useState({})

    const handleChange = (e) => {
        const { id, value } = e.target
        setFormData(prev => ({ ...prev, [id]: value }))
        setErrors(prev => ({ ...prev, [id]: '' }))
    }

    const handleSubmit = async () => {
        const { password, confirmPassword } = formData
        const newErrors = {}

        if (!password || password.length < 6) {
            newErrors.password = 'Minimum 6 characters'
        }
        if (password !== confirmPassword) {
            newErrors.confirmPassword = 'Passwords do not match'
        }

        if (Object.keys(newErrors).length) {
            setErrors(newErrors)
            return
        }

        try {
            const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/auth/reset-password`, {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    resetToken: resetToken,
                    password,
                    confirmPassword
                })
            })
            const data = await res.json()
            if (!res.ok) throw new Error(data.message || 'Failed to reset password')

            toast({
                title: 'Password reset successfully',
                status: 'success',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            })
            onClose()
        } catch (err) {
            toast({
                title: 'Error',
                description: err.message,
                status: 'error',
                variant: 'left-accent',
                duration: 4000,
                isClosable: true
            })
        }
    }

    return (
        <Modal isOpen={isOpen} onClose={onClose} isCentered size="md" zIndex={99999}>
            <ModalOverlay />
            <ModalContent p={6} bg="white" containerProps={{ zIndex: '99999' }}>
                <ModalHeader>Reset Your Password</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                    <Stack spacing={4}>
                        <FormControl id="password" isInvalid={!!errors.password} isRequired>
                            <FormLabel>New Password</FormLabel>
                            <Input type="password" value={formData.password} onChange={handleChange} />
                            <FormErrorMessage>{errors.password}</FormErrorMessage>
                        </FormControl>
                        <FormControl id="confirmPassword" isInvalid={!!errors.confirmPassword} isRequired>
                            <FormLabel>Confirm Password</FormLabel>
                            <Input type="password" value={formData.confirmPassword} onChange={handleChange} />
                            <FormErrorMessage>{errors.confirmPassword}</FormErrorMessage>
                        </FormControl>
                    </Stack>
                </ModalBody>
                <ModalFooter justifyContent="center">
                    <Button variant="solid-green-btn" onClick={handleSubmit}>
                        Reset Password
                    </Button>
                </ModalFooter>
            </ModalContent>
        </Modal>
    )
}

export default ResetPasswordModal
